define(
	'Tavanoteam.TavanoTeam_Sticky_Header_Extension.StickyHeader'
	, [
		'jQuery'
	]
	, function (
		jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var environment = container.getComponent("Environment");
				var layout = container.getComponent('Layout');

				if (!environment.isPageGenerator()) { // isPageGenerator() - to avoid SEO render

					// Scroll Settings
					var targetElement = 'header#site-header';
					var stickyHeaderClass = 'sticky-header';
					var togglePoint = environment.getConfig('tavanoTeamStickyHeaderExtension.scrollTogglePoint');
					var stickyHeaderStatus = false;
					var lastScrollPoint = 0;
					var actualScollPoint = 0;
					var tabletMaxWidth = 991;
					var scrollDownHide = environment.getConfig('tavanoTeamStickyHeaderExtension.scrollDownHide');

					// Get Sticky Header Data
					var mediumScreenDisplayOptions = environment.getConfig('tavanoTeamStickyHeaderExtension.displayMediumScreen');
					var largeScreenDisplayOptions = environment.getConfig('tavanoTeamStickyHeaderExtension.displayLargeScreen');

					var getStickyHeaderCartDisplay = function () {	
						return (largeScreenDisplayOptions.includes('Show Cart') ? 'tt-ext-sticky-header-screen-large ' : '') +
							(mediumScreenDisplayOptions.includes('Show Cart') ? 'tt-ext-sticky-header-screen-medium' : '');
					};

					var getStickyHeaderSearchDisplay = function () {
						return (largeScreenDisplayOptions.includes('Show Search') ? 'tt-ext-sticky-header-screen-large ' : '') +
							(mediumScreenDisplayOptions.includes('Show Search') ? 'tt-ext-sticky-header-screen-medium' : '');
					};

					var getStickyHeaderLogoClass = function () {
						var logoUrl = environment.getConfig('tavanoTeamStickyHeaderExtension.logoUrl');
						
						return !!logoUrl ? 'tt-ext-sticky-header-logo-enabled' : '';
					};

					var getStickyHeaderLogoWidth = function () {
						var logoWidth = environment.getConfig('tavanoTeamStickyHeaderExtension.logoWidth');
						
						logoWidth = logoWidth ? logoWidth : 200;
						logoWidth = 'style="max-width:' + logoWidth + 'px"';
						
						return logoWidth;
					};

					var getStickyHeaderNavigationClasses = function () {
						var linksPadding = environment.getConfig('tavanoTeamStickyHeaderExtension.linksPadding');
						
						return (linksPadding && linksPadding != 'unset') ? 'tt-ext-sticky-header-links-p-' + linksPadding : '';
					};

					var stickyHeaderData = {
						logoClass: getStickyHeaderLogoClass(),
						logoWidth: getStickyHeaderLogoWidth(),
						cartClass: getStickyHeaderCartDisplay(),
						searchClass: getStickyHeaderSearchDisplay(),
						navClasses: getStickyHeaderNavigationClasses()
					};

					// Send Sticky Header Data
					if (window.innerWidth > tabletMaxWidth) { // Send data only on Desktop
						layout.addToViewContextDefinition('Header.View', 'ttStickyHeaderExtension', 'array', function (context) {
							return stickyHeaderData;
						});

						layout.addToViewContextDefinition('Header.Logo.View', 'ttStickyHeaderExtension', 'array', function (context) {
							var logoUrl = environment.getConfig('tavanoTeamStickyHeaderExtension.logoUrl');
							
							return {
								logoUrl: !!logoUrl ? logoUrl : false
							}
						});
					}

					jQuery(document).ready(function () {
						var stickyHeaderEnable = -1;

						var findStickyHeader = function () {
							stickyHeaderEnable = jQuery(".tt-ext-sticky-header").length;
						}

						// Check for open menu nav, cart, search 
						var closeMenus = function () {	
							// Close Navigation Menu
							jQuery('.header-menu-level1 .open').removeClass('open');
							// Close Mini Cart
							jQuery('[data-view="Header.MiniCart"].open').removeClass('open');
							// Close Site Settings
							jQuery('.header-subheader-settings.open').removeClass('open');
							// Close Search
							jQuery('.header-menu-search-link.active').removeClass('active');
							jQuery('.site-search-button-link.active').removeClass('active');
							jQuery('.tt-menu.tt-open').removeClass('tt-open');
							
							if (jQuery('.tt-menu').length > 0) {
								if (jQuery('.tt-menu').prop("style").display === "block") {
									jQuery('.tt-menu').prop("style").display = "none";
								}
							}
							
							if (jQuery('.site-search').length > 0) {
								if (jQuery('.site-search').prop("style").display === "block") {
									jQuery('.site-search').prop("style").display = "";
								}
							}
						}

						var showStickyHeader = function () {
							stickyHeaderStatus = true;
							jQuery(targetElement).addClass(stickyHeaderClass);
							closeMenus();
						}

						var hideStickyHeader = function () {
							stickyHeaderStatus = false;
							jQuery(targetElement).removeClass(stickyHeaderClass);
							closeMenus();
						}

						// Scroll
						if (stickyHeaderEnable && window.innerWidth > tabletMaxWidth) { // Only Desktop Scroll Event	
							jQuery(window).scroll(function () {
								if (stickyHeaderEnable === -1) {
									findStickyHeader();
								}
								
								if (stickyHeaderEnable > 0) {
									actualScollPoint = window.pageYOffset || document.documentElement.scrollTop;
									
									if ((actualScollPoint > lastScrollPoint && scrollDownHide) || actualScollPoint < togglePoint) {
										if (stickyHeaderStatus) {
											hideStickyHeader();
										}
									} else {
										if (!stickyHeaderStatus) {
											showStickyHeader();
										}
									}
									
									lastScrollPoint = (actualScollPoint <= 0) ? 0 : actualScollPoint;
								}
							});
						}

						// Resize
						jQuery(window).resize(function () {
							if (stickyHeaderEnable === -1) {
								findStickyHeader();
							}
							
							if (stickyHeaderEnable > 0 && stickyHeaderStatus) {
								hideStickyHeader();
							}
						});
					});
				}
			}
		};
	}
);
